import * as _hm from './_hm';
import * as _ht from './_ht';

export const eptCsv = (pz: { // export
  hdrz: _ht.dz,
  bdys: _ht.dz[],
  fileName: _ht.s,
}) => {

  let _csv = '';
  Object.keys(pz.hdrz).map( (_key) => {
    _csv += (_csv != '') ? `,"${pz.hdrz[_key]}"` : `"${pz.hdrz[_key]}"`;
  });
  _csv += (_csv != '') ? '\n' : '';
  _csv += pz.bdys.reduce( (_prev1, _rowz) => {
    let _s = '';
    Object.keys(pz.hdrz).map( (_key) => {
      _s += ((_s != '') ? `,` : ``) + `"${_rowz[_key] ?? ''}"`;
    });
    return ((_prev1 != '') ? `${_prev1}\n` : ``) + _s
  }, '');

  eptText({      // ファイル出力
    fileName: pz.fileName, 
    vle: _csv,
  });

};

export const eptText = (pd: { // export file, only for web
    fileName: _ht.s,
    vle: _ht.s,
}) => {
    const _bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const _blob = new Blob([_bom, pd.vle], {type: "text/plain;charset=utf-8"});
    const _link = document.createElement("a");
    if (_link.download !== undefined) { // feature detection
        const _url = URL.createObjectURL(_blob);
        _link.setAttribute("href", _url);
        _link.setAttribute("download", pd.fileName);
        _link.style.visibility = 'hidden';
        document.body.appendChild(_link);
        _link.click();
        document.body.removeChild(_link);
    }
};
